export default "__VITE_PUBLIC_ASSET__9b8bbc6d__"